import profileImage from "../../assets/images/hero-picture.png";

function Hero() {
  const handleLearnMore = () => {
    const aboutSection = document.getElementById("about");
    if (aboutSection) {
      aboutSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section
      id="hero"
      className="min-h-screen flex items-center relative overflow-hidden bg-hero-background"
    >
      <div className="container mx-auto px-6 md:px-12 lg:px-20 py-20">
        <div className="flex flex-col-reverse lg:grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          {/* Left content */}
          <div className="relative z-10">
            <h1 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-hero-foreground mb-2 inline-block">
              Software Engineer
            </h1>

            <p className="font-body text-muted-foreground text-lg mt-6 mb-4">
              Based in Salt Lake City, UT
            </p>

            <p className="font-body text-hero-foreground/80 text-lg leading-relaxed max-w-lg mb-8">
              Hi, I'm Jack a Software Engineering graduate with real‑world
              experience in Systems Engineering and DevOps. I design and build
              automated, cloud‑native solutions that are secure, maintainable,
              and built to scale.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-start">
              <button
                onClick={handleLearnMore}
                className="w-fit px-8 py-3 bg-hero-foreground text-hero-background font-semibold rounded-lg hover:opacity-90 transition-opacity"
              >
                learn More...
              </button>
              <a
                href="/resume-online"
                target="_blank"
                rel="noopener noreferrer"
                className="w-fit px-8 py-3 border-2 border-hero-foreground text-hero-foreground font-semibold rounded-lg hover:bg-hero-foreground hover:text-hero-background transition-colors"
              >
                Resume
              </a>
            </div>
          </div>

          {/* Right - Photo with blue circle - unified container for dynamic scaling */}
          <div className="relative flex justify-center items-center lg:justify-end">
            {/* Container that holds both circle and image together */}
            <div className="relative w-80 h-96 sm:w-96 sm:h-[480px] lg:w-[420px] lg:h-[520px]">
              {/* Blue circle decoration - scales with container */}
              <div className="absolute w-80 h-80 sm:w-[420px] sm:h-[420px] lg:w-[520px] lg:h-[520px] bg-geo-primary rounded-full  top-1/2 -translate-y-1/2" />

              {/* Photo - positioned within container */}
              <div className="absolute right-0 lg:right-auto lg:left-1/2 lg:-translate-x-1/2 top-1/2 -translate-y-1/2 w-full h-full overflow-hidden rounded-lg z-10">
                <img
                  src={profileImage}
                  alt="Jack Aguilera"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
